import React from "react";
import { getStatusStyle, STATUS_LABELS } from "../utils/statusColors";
import { badgeBase } from "../utils/designTokens";

/**
 * Badge de estado unificado.
 *
 * Props:
 * - status (string): clave del estado (ej: "pendiente", "activa", "pagado")
 * - label (string, opcional): texto a mostrar (si no se pasa, usa STATUS_LABELS)
 * - variant ("fill" | "dot"): estilo del badge
 * - icon (ReactElement, opcional): icono antes del texto
 * - size ("sm" | "md"): tamaño
 */
const StatusBadge = ({ status, label, variant = "fill", icon, size = "md" }) => {
  const style = getStatusStyle(status);
  const displayLabel =
    label ||
    STATUS_LABELS[
      status
        ?.toLowerCase()
        .trim()
        .replace(/\s+/g, "_")
        .replace(/[áà]/g, "a")
        .replace(/[éè]/g, "e")
        .replace(/[íì]/g, "i")
        .replace(/[óò]/g, "o")
        .replace(/[úù]/g, "u")
    ] ||
    status;

  if (variant === "dot") {
    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          fontSize: size === "sm" ? 11 : 13,
          fontWeight: 400,
          color: style.text,
        }}
      >
        <span
          style={{
            width: size === "sm" ? 6 : 8,
            height: size === "sm" ? 6 : 8,
            borderRadius: "50%",
            backgroundColor: style.text,
            flexShrink: 0,
          }}
        />
        {displayLabel}
      </span>
    );
  }

  return (
    <span
      style={{
        ...badgeBase,
        backgroundColor: style.bg,
        color: style.text,
        border: `1px solid ${style.border}`,
        fontSize: size === "sm" ? 10 : 12,
        padding: size === "sm" ? "2px 8px" : "4px 12px",
        transition: "all 0.15s ease",
      }}
    >
      {icon && <span style={{ display: "flex", flexShrink: 0 }}>{icon}</span>}
      {displayLabel}
    </span>
  );
};

export default StatusBadge;
